import type { TuitionErrorCode } from '@/types/subscription'

/**
 * External tuition portal origin (e.g. Launchpad / campus).
 * Set `VITE_APP_TUITION_URL`; default `https://campus.outtalent.com`.
 */
export const TUITION_URL = (
  import.meta.env.VITE_APP_TUITION_URL || 'https://campus.outtalent.com'
).replace(/\/$/, '')

/** Default when API omits `action_url` (e.g. renew / manage). */
export const DEFAULT_TUITION_PATH = '/tuition/manage'

/** HTTP statuses treated as tuition / access errors from the API. */
export const TUITION_ERROR_STATUS_CODES = [402, 403]

export const TUITION_ERROR_MESSAGES: Record<TuitionErrorCode, string> = {
  tuition_required: 'Tuition is required to access this feature',
  tuition_past_due: 'Your tuition payment is past due',
  tuition_expired: 'Your tuition has expired',
  tuition_cancelled: 'Your tuition has been cancelled',
  tuition_suspended: 'Your tuition is currently suspended',
  payment_failed: 'Payment processing failed',
  trial_expired: 'Your trial period has expired'
}

export const TUITION_ERROR_ACTIONS: Record<TuitionErrorCode, string> = {
  tuition_required: 'Manage tuition',
  tuition_past_due: 'Update payment method',
  tuition_expired: 'Renew tuition',
  tuition_cancelled: 'Reactivate tuition',
  tuition_suspended: 'Contact support',
  payment_failed: 'Update payment method',
  trial_expired: 'Manage tuition'
}
